<template>
  <div class="login-container"
       ref="login"
       @keyup.enter.native="handleLogin">
    <top-color v-show="false"></top-color>
    <div class="login-weaper animated bounceInDown">
      <div class="login-left">
        <div class="login-time">
          {{time}}
        </div>
        <div>
          <img class="img" :src="logo" alt="">

        </div>
        <p class="title">{{ info || $t('login.info') }}</p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <h4 class="login-title">
            {{ $t('login.title') }}
            <top-lang></top-lang>
          </h4>
          <userLogin v-if="activeName==='user'"></userLogin>
          <codeLogin v-else-if="activeName==='code'"></codeLogin>
          <!-- <thirdLogin v-else-if="activeName==='third'"></thirdLogin> -->
          <div class="login-menu">
            <!-- <a href="#" @click.stop="activeName='user'">{{ $t('login.userLogin') }}</a> -->
            <!-- <a href="#" @click.stop="activeName='third'">{{ $t('login.thirdLogin') }}</a> -->
          </div>
        </div>

      </div>
    </div >
      <div class="logo_footer">免责声明：本站部分资讯来源于网络，如有侵权请及时联系客服，我们将尽快处理 <br>
      <div class="text-align:center"><a target="_blank" href="https://beian.miit.gov.cn">浙ICP备18056360号-2</a></div>
     </div>
    <register v-model="showRegister" @success="handleRegisterSuccess" />
  </div>
</template>
<script>
  import userLogin from "./userlogin";
  import codeLogin from "./codelogin";
  import thirdLogin from "./thirdlogin";
  import register from "@/page/register/register";
  import {mapGetters} from "vuex";
  import {dateFormat} from "@/util/date";
  import {validatenull} from "@/util/validate";
  import topLang from "@/page/index/top/top-lang";
  import topColor from "@/page/index/top/top-color";
  import {getQueryString, getTopUrl} from "@/util/util";
  export default {
    name: "login",
    components: {
      userLogin,
      codeLogin,
      thirdLogin,
      topLang,
      topColor,
      register
    },
    data() {
      return {
        time: "",
        logo: '',
        title:'',
        info: '',
        activeName: "user",
        showRegister: false,
        socialForm: {
          tenantId: "",
          source: "",
          code: "",
          state: "",
        }
      };
    },
    watch: {
      $route() {
        this.handleLogin();
      }
    },
    created() {
      this.handleLogin();
      this.getTime();

    },
    mounted() {
      if(this.website.roleType == 'factory'){
         this.logo = require('@/assets/logo3.png')
      }else if(this.website.roleType == 'gen'){
        this.logo = require('@/assets/logo2.png')
      } else {
        this.logo = require('@/assets/logo1.png')
      }
    },
    computed: {
      ...mapGetters(["website", "tagWel"])
    },
    props: [],
    methods: {


      getTime() {
        setInterval(() => {
          this.time = dateFormat(new Date());
        }, 1000);
      },
      handleLogin() {
        const topUrl = getTopUrl();
        const redirectUrl = "/oauth/redirect/";
        this.socialForm.source = getQueryString("source");
        this.socialForm.code = getQueryString("code");
        this.socialForm.state = getQueryString("state");
        if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
          let source = topUrl.split("?")[0];
          source = source.split(redirectUrl)[1];
          this.socialForm.source = source;
        }
        if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
          const loading = this.$loading({
            lock: true,
            text: '第三方系统登录中,请稍后。。。',
            spinner: "el-icon-loading"
          });
          this.$store.dispatch("LoginBySocial", this.socialForm).then(() => {
            window.location.href = topUrl.split(redirectUrl)[0];
            this.$router.push({path: this.tagWel.value});
            loading.close();
          }).catch(() => {
            loading.close();
          });
        }
      },
      handleRegisterSuccess() {
        this.$message.success('注册成功，请登录');
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/login.scss";
  .logo_footer{
    position: absolute;
    bottom: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    a{
      color: #fff;
    }
  }
</style>
